module.exports = __webpack_public_path__ + "img/panch_cuento_1.4f2bb521.png";